export const CHECK_AUTH = "checkAuth";
export const FETCH_USERS = "fetchUsers";
export const FILTER_USERS = "filterUsers";
export const FETCH_DASHBOARDS = "fetchDashboards";
export const LOGIN = "login";
export const RESET_PASSWORD = "resetPassword";
export const LOGOUT = "logout";
export const REGISTER = "register";
export const UPDATE_USER = "updateUser";
export const UPDATE_USER_BY_ADMIN = "adminUpdateUser";
export const ADMIN_FETCH_USER = "adminFetchUser";
export const FETCH_SESSIONS = "fetchSessions";
export const FILTER_SESSIONS = "filterSessions";
export const UPDATE_SESSION = "updateSession";
export const FETCH_PRACTICE_COUNTS = "fetchPracticeCounts";
export const FETCH_STUDENTS = "fetchStudents";
export const FILTER_STUDENTS = "filterStudents";
export const UPDATE_TEAM = "updateTeam";
export const RESET_STUDENTS = "resetStudents";
export const FETCH_STATS = "fetchStats";
export const FETCH_SELF_STUDY = "fetchSelfStudy";
export const FETCH_MODULE_DETAILS = "fetchModuleDetails";
